/* eslint-disable react/no-multi-comp */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import * as PaymentsActions from "../../actions/paymentsActions";
import PaymentCardForm from './PaymentCardForm';

// const RECAPTCHA_KEY = '6Lcv7LoUAAAAAG5drxQTeMQ6DRfCOFN05eKHXHip';


function PaymentCards(props) {
  const [formVisibility, setFormVisibility] = useState(false);
  const [editFormVisibility, setEditFormVisibility] = useState(false);
  const [visibleCardId, setVisibleCardId] = useState("");
  const [availableCards, setAvailableCards] = useState([]);
  const loadPaymentMethods = () => {
    props.dispatch(
      PaymentsActions.getAllUserPaymentMethods((response) => {
        if (response.status) {
          setAvailableCards(response.data.data);
        }
      })
    );
  };

  useEffect(() => {
    loadPaymentMethods();
  }, []);


  const deletePaymentCard = (cardId) => {
    const {onDeleteCard} = props;
    props.dispatch(PaymentsActions.deleteCard(cardId, response => {
      if (response.status) {
        loadPaymentMethods();
        onDeleteCard && onDeleteCard();
      } else {
        alert('Failed to delete the selected Payment Method');
      }
    }));
  };

  const { viewMode, onSelectCard, selectedCard } = props;

  return (
    <div className="payment-cards-container">
      {availableCards && availableCards.length > 0 ? (
        availableCards.map((card, idx) => {
          return (
            <div className="info-row" key={`card_${idx}_row`}>
              <div className="content-left">{`${card.card.brand}: XXXXXXXXXXXX ${card.card.last4}`}</div>
              {viewMode && viewMode === "select" ? (
                <div className="content-right">
                  <i
                    className={`fa fa${
                      selectedCard && card.id === selectedCard.id ? "-dot" : ""
                    }-circle-o`}
                    onClick={() => (onSelectCard ? onSelectCard(card) : null)}
                  />
                </div>
              ) : null}
              {viewMode && viewMode === "edit" ? (
                <div className="content-right">
                  <i
                    className="fa fa-trash-o"
                    onClick={() =>
                      deletePaymentCard(card.id)
                    }
                  />
                  <i
                    className="fa fa-eye"
                    onClick={() => {
                      setEditFormVisibility(true);
                      setVisibleCardId(card.id);
                    }}
                  />
                </div>
              ) : null}
              {editFormVisibility && visibleCardId === card.id ? (
                <div className="payment-form">
                  <div className="row title-row info-row">
                    <div className="col-sm-10">View Payment Method</div>
                    <div className="col-sm-2 button-container">
                      <i
                        className="fa fa-close"
                        onClick={() => setEditFormVisibility(false)}
                      />
                    </div>
                  </div>
                  <div className="row form">
                    <div className="col-md-12">
                      <input
                        disabled
                        placeholder="Name on Card"
                        value={card.billing_details.name}
                      />
                    </div>
                    <div className="col-md-12">
                      <input
                        placeholder="Card Number"
                        value={`xxxx-xxxx-xxxx-${card.card.last4}`}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        disabled
                        placeholder="Expiry Month"
                        value={card.card.exp_month}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        disabled
                        placeholder="Expiry Year"
                        value={card.card.exp_year}
                      />
                    </div>
                    <div className="col-md-12">
                      <input
                        disabled
                        placeholder="Billing Address"
                        value={card.billing_details.address.line1}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing City"
                        value={card.billing_details.address.city}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing State"
                        value={card.billing_details.address.state}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        disabled
                        placeholder="Billing Zip"
                        value={card.billing_details.address.postal_code}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          );
        })
      ) : (
        <div className="info-row">
          <span className="text-italic">No Payment Method Added</span>
        </div>
      )}
      {viewMode && viewMode === "edit" ? (
        formVisibility ? (
          <div className="payment-form">
            <div className="row title-row info-row">
              <div className="col-sm-10">Add New Payment Method</div>
              <div className="col-sm-2 button-container">
                <i
                  className="fa fa-close"
                  onClick={() => setFormVisibility(false)}
                />
              </div>
            </div>
            <PaymentCardForm 
              onAddCardRequest={() => {
                loadPaymentMethods();
                setFormVisibility(false);
                props.onAddCardRequest && props.onAddCardRequest();
              }}
              dispatch={props.dispatch}
            />
          </div>
        ) : (
          <div className="info-row">
            <a
              href="javascript:void(0)"
              onClick={() => setFormVisibility(true)}
            >
              Add New Payment Method
            </a>
          </div>
        )
      ) : null}
    </div>
  );
}

export default PaymentCards;



// WEBPACK FOOTER //
// ./src/components/checkout/PaymentCards.js